<ngx-simplebar [options]="{ autoHide: false }" class="widget expectedEnergyLoss">
  <app-expected-energy-loss
    [energyLoss]="energyToolFacade.energyLoss()"
    [expectedEnergyLossPerDay]="energyToolFacade.expectedEnergyLossPerDay()"
    [energyCost]="energyToolFacade.energyCost()"
    (changeTimeframeEvent)="onChangeTimeExpecteEnergyLoss($event)"
  ></app-expected-energy-loss>
</ngx-simplebar>

<ngx-simplebar [options]="{ autoHide: false }" class="widget doughnutChart">
  <app-doughnut-chart
    [chartData]="energyToolFacade.doughnutChartEnergyLoss()"
    [sourceType]="sourceType"
    (changeTimeframeEvent)="onChangeTimeDoughnutChart($event)"
    chartId="customerDoughnutChart"
  ></app-doughnut-chart>
</ngx-simplebar>

<ngx-simplebar [options]="{ autoHide: false }" class="widget barChart">
  <app-bar-chart
    [chartData]="energyToolFacade.barChartEnergyLoss()"
    (changeTimeframeEvent)="onChangeTimeBarChart($event)"
    [sourceType]="sourceType"
    [sourceId]="sourceId"
    chartId="customerBarChart"
  ></app-bar-chart>
</ngx-simplebar>

<ngx-simplebar [options]="{ autoHide: false }" class="widget lineChart">
  <app-line-chart
    [chartData]="energyToolFacade.lineChartEnergyLoss()"
    (changeTimeframeEvent)="onChangeTimeLineChart($event)"
    [sourceType]="sourceType"
    [sourceId]="sourceId"
    chartId="customerLineChart"
  ></app-line-chart>
</ngx-simplebar>
<ngx-simplebar [options]="{ autoHide: false }" class="widget energyExport">
  @if (sourceId && sourceType && energyToolFacade.customerLabel()) {
    <app-energy-export
      style="height: 100%"
      [assetId]="sourceId"
      [assetType]="sourceType"
      [assetLabel]="energyToolFacade.customerLabel()!"
    ></app-energy-export>
  }
</ngx-simplebar>
